export const maxFileSize = 5 * 1024 * 1024; // 5MB
export const allowedExtensions = /(\.xls|\.xlsx)$/i;
export const allowedMimeTypes = [
  'application/vnd.ms-excel', // .xls
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
];
